// src/components/Home.js

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchLookups, initOrgUser } from 'src/store/apps/lookup';
import {
    Container,
    Typography,
    Grid,
    useTheme,
    Box,
    IconButton,
    CircularProgress,
    Avatar,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

// Import your custom card components
import AddChannelsCard from './AddChannelsCard';
import CreatePostsCard from './CreatePostsCard';
import ScheduleOrganizeCard from './ScheduleOrganizeCard';
import InsightsCard from './InsightsCard';
// ... other imports

const Home = ({ user }) => {
    const dispatch = useDispatch();
    const theme = useTheme();

    const [loading, setLoading] = useState(false);
    const [lastUpdatedTime, setLastUpdatedTime] = useState(new Date());

    useEffect(() => {
        const subscriptionId = sessionStorage.getItem('subscriptionId');
        if (subscriptionId) {
            window.location.href = '/payment';
        }
    }, []);

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return 'Good morning';
        if (hour < 18) return 'Good afternoon';
        return 'Good evening';
    };

    useEffect(() => {
        dispatch(fetchLookups());
        dispatch(initOrgUser());
        // Update the last updated time when data is fetched
        setLastUpdatedTime(new Date());
    }, [dispatch]);

    const handleRefresh = () => {
        setLoading(true);
        // Simulate data fetching or reloading the page
        setTimeout(() => {
            // Reload data here (e.g., re-dispatch actions)
            dispatch(fetchLookups());
            dispatch(initOrgUser());
            setLastUpdatedTime(new Date());
            setLoading(false);
        }, 2000); // simulate a 2-second loading time
    };

    return (
        <Container maxWidth='xl'>
            {/* Greeting and Refresh Section */}
            <Box
                display='flex'
                alignItems='center'
                justifyContent='space-between'
                sx={{ mb: 4 }}
            >
                <Box display='flex' alignItems='center'>
                    {/*<Avatar*/}
                    {/*    sx={{*/}
                    {/*        width: 56,*/}
                    {/*        height: 56,*/}
                    {/*        mr: 2,*/}
                    {/*        bgcolor: theme.palette.primary.main,*/}
                    {/*        fontSize: 24,*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {user.name.charAt(0).toUpperCase()}*/}
                    {/*</Avatar>*/}
                    <Box>
                        <Typography variant='h4' sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                            {getGreeting()} <span style={{ marginRight: '2px' }}>👋</span>, {user.name.split('@')[0]}!
                        </Typography>

                        <Box display='flex' alignItems='center' mt={0}>
                            <Typography
                                variant='body2'
                                sx={{ color: 'text.secondary', mr: 1 }}
                            >
                                Last updated: {lastUpdatedTime.toLocaleTimeString()}
                            </Typography>
                            <IconButton
                                onClick={handleRefresh}
                                sx={{ color: theme.palette.primary.main }}
                                size="small"
                            >
                                <RefreshIcon fontSize="8px" />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {loading ? (
                // Show loader when loading
                <Box
                    display='flex'
                    justifyContent='center'
                    alignItems='center'
                    sx={{ height: '70vh' }}
                >
                    <CircularProgress size={60} />
                </Box>
            ) : (
                // Existing content
                <>
                    {/* Quick Start Section */}
                    <Typography
                        variant='h5'
                        sx={{ fontWeight: 'bold', color: 'text.primary', mt: 6 }}
                    >
                        Quick Start
                    </Typography>
                    <Typography variant='body2' sx={{ mb: 4 }}>
                        Get started quickly by adding channels, scheduling posts, and
                        managing your social content seamlessly from one place. Dive into
                        analytics and insights, invite team members, and organize your
                        strategy efficiently.
                    </Typography>

                    {/* Cards Section */}
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <AddChannelsCard />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <CreatePostsCard />
                        </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <InsightsCard />
                            </Grid>
                        <Grid item xs={12}>
                            <ScheduleOrganizeCard />
                        </Grid>

                    </Grid>
                </>
            )}
        </Container>
    );
};

export default Home;
